import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFridge: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"fridge"} maskId="square-filled-radius-0-stroke-1-IconFridge"><path fillRule="evenodd" clipRule="evenodd" d="M4 10V2H20V10H4ZM16 6H15V8H16V6Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M4 11V22H20V11H4ZM16 13V15H15V13H16Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFridge;
